import { FreeAddOnUsage } from "@addons/components/MeteredAddOnUsage";
import { IAddOnSlotProps, IMeteredAddOnDescriptor } from "../types";

export default function FreeProductAnalyticsUsageGraph({
  addOn: { subscribed, getUsage },
}: IAddOnSlotProps<IMeteredAddOnDescriptor>) {
  const usage = getUsage();

  if (!subscribed || !usage) {
    return null;
  }

  return (
    <FreeAddOnUsage
      dataTestId="ProductAnalyticsUsageListing"
      unitLabel="Ingested events"
      usage={usage}
    />
  );
}
